export default "/images/vendor/flag-icon-css/flags/1x1/li.svg?572f90277090beca0d31315cec8e1bf4";